export enum UserRoles {
  Admin = "Admin",
  Member = "Member",
  Teacher = "Teacher",
  Staff = "Staff",
  Choreographer = "Choreographer",
}
